// Shared category vocabulary for "flag this property for review" alerts —
// must match the server enum in propertyReviewFlag.model.js.
export const FLAG_CATEGORIES = [
  { value: 'need_help', label: 'Need Help' },
  { value: 'need_more_info', label: 'Need More Info' },
  { value: 'unsure', label: 'Unsure' }
]

const labelByValue = Object.fromEntries(FLAG_CATEGORIES.map(c => [c.value, c.label]))

export const flagCategoryLabel = (value) => labelByValue[value] || value || ''

// Open flags keyed by aspire property id (first open flag per property wins —
// the UI prevents stacking a second open flag on an already-flagged property).
export const buildOpenFlagMap = (flags = []) => {
  const byPropertyId = {}
  flags.forEach(flag => {
    if (!flag || flag.status !== 'open') return
    const id = Number(flag.aspirePropertyId)
    if (!Number.isFinite(id) || byPropertyId[id]) return
    byPropertyId[id] = flag
  })
  return byPropertyId
}
